import { makeRequest } from 'utils/requestLogger';

export default (id, inviteCode) =>
  makeRequest('post', '/api/live_discussions/join', {
    live_discussion_id: id,
    invite_code: inviteCode,
  });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/joinLiveDiscussion.js